// extracted by mini-css-extract-plugin
export default {"wrapper":"coacheeCurrentSession_wrapper__g71+m"};